import styled from "styled-components";

export const SideBarWrapperStyled = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.3rem 1rem;
    .imgBox{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid ${({theme})=> theme === "dark" ? '#fff' : '#0C1E28'};
    }
    .welcome{
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: start;
        h4{
            color: #5fbec5;
            font-size: 1.3rem;
        }
    }

`


export const SideBarItemsStyled = styled.div`
    box-sizing: border-box;
    border-radius: 5px;
    color: ${(theme) => theme === 'dark' ? '#fff' : '#5fbec5'};
    width: 100%;
    margin-bottom: 20px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
`;

export const HelperButtonsStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
    @media only screen and (min-width: 992px) {
        margin-bottom: 0;

    }
`

export const LinksButtonsStyled = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: ${({$border}) => $border};
    background: none;
    color: ${({ color }) => color || 'inherit'};
    gap: 1rem;
    width: 95%;
    padding: 1rem 0.5rem;
    cursor: pointer;
    transition: 0.3s ease-in-out;
    transform: scale(1);
    &:hover{
        background: ${({$logout})=> $logout ? 'crimson' : '#5fbec5' };
        color: #fff;
        border: none;
        
    }
    a{
        color: #fff;
    }
    

`;